import { render } from "./App.vue?vue&type=template&id=582b4570"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "leaflet/dist/leaflet.css?vue&type=style&index=0&lang=css"
import "./assets/tailwind.css?vue&type=style&index=1&lang=css"
import "./App.vue?vue&type=style&index=2&id=582b4570&lang=scss"

import exportComponent from "/Users/johan/dev/litteraturkartan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__